const getters = {
  getSelectedNote: (state) => state.selectedNote,
  getSelectedDataOnSped: (state) => state.selectedDataOnSped,
  getShowAccountsGrid: (state) => state.showAccountsGrid,
  getAllSelectedDataOnNfe: (state) => state.allSelectedDataOnNfe,
  getDidChangeCta: (state) => state.didChangeCta,
  getSelectedSped: (state) => state.selectedSped,
  getCfopList: (state) => state.cfopList,
  getFavoriteAccounts: (state) => state.favoriteAccounts,
  getIsMovIcms: (state) => state.isMovIcms,
  getLastNoteOpen: (state) => state.lastNoteOpen,
  getKeysSelectedToSum: (state) => state.keysSelectedToSum,
  getSelectedKeysToShowSped: (state) => state.selectedKeysToShowSped,
  getSelectedKeysToShowNfe: (state) => state.selectedKeysToShowNfe,
  getSelectedNoteVlIcmsClient: (state) => state.selectedNoteVlIcmsClient,
  getViewOnlyMode: (state) => state.viewOnlyMode,
};

export default getters;
